import React from 'react'

const FormContext = React.createContext({ handleChange: undefined, params: {} })
export default FormContext